const checkNumberRule = (text) => {
  const numberReg = /\.\d{3,}$/;
  return numberReg.test(text);
};

export default checkNumberRule;
